import { NoticeBox } from '@factorialco/deprecated-design-system'
import { EmployeeRootPageEmployeeFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { terminationReasonTranslation } from 'modules/bookkeepers/lib/dynamicTranslations'

interface Props {
  employee: EmployeeRootPageEmployeeFragment
  canTerminateEmployee: boolean
}

const TerminationBanner = ({ employee, canTerminateEmployee }: Props) => {
  if (!employee.terminatedOn || !canTerminateEmployee) {
    return null
  }

  const date = i18nDateToString(moment(employee.terminatedOn), 'ui')
  const terminatedOn = stringToDate(employee.terminatedOn, 'backend')
  const terminationTypeDescription = employee.terminationTypeDescription
    ? ` - ${employee.terminationTypeDescription}`
    : employee.terminationReasonType
    ? ` - ${terminationReasonTranslation(employee.terminationReasonType)}`
    : ''

  let message = i18n.t('employees.terminating_banner', {
    date: date,
  })
  let tooltipLabel = i18n.t('employees.terminating_tooltip', {
    date: date,
  })

  const now = moment()
  const isTerminated = terminatedOn < now
  if (isTerminated) {
    message = i18n.t('employees.terminated_banner', {
      date,
    })
    tooltipLabel = i18n.t('employees.terminated_tooltip', {
      date,
    })
  }

  return (
    <NoticeBox
      message={message + terminationTypeDescription}
      justifyContent="center"
      tooltipLabel={tooltipLabel}
    />
  )
}

export default TerminationBanner
